import script from "./CertificateTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateTable.vue?vue&type=script&setup=true&lang=js"

import "./CertificateTable.vue?vue&type=style&index=0&id=723e85f7&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723e85f7"]])

export default __exports__